import { useState } from 'react';
import { Pill } from '../pill';
import { styles } from '../../constants';

const pillStyle = {
  fontWeight: 'bold',
  backgroundColorx: '#fff',
  border: '1px solid #ddd',
  color: '#555',
  position: 'relative',
  top: 1,
};

export const TableFromObject = ({ obj, compact, percent, headerStyle }) => {
  headerStyle ||= {};
  percent ||= 20;

  const nodes = Object.keys(obj || {}).map((key, idx) => {
    const val = obj[key];
    const ser = typeof val == 'string' ? val : JSON.stringify(val);
    const background = idx % 2 == 0 ? '#f3f3f3' : '#fff';
    return (
      <div key={key} style={{ display: 'flex', alignItems: 'center', padding: '4px 6px', background }}>
        <div style={{ width: `${percent}%`, fontSize: 13 }}>
          <b>{key}</b>
        </div>
        <div style={{ width: `${100 - percent}%`, fontSize: 13, ...styles.textOverflowStyle }}>{ser}</div>
      </div>
    );
  });

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>{nodes}</div>
    </div>
  );
};
